export enum Validation {
  'onboarding.jobCategory.required' = 'onboarding.jobCategory.required',
}
